import { Component, Input } from '@angular/core';
import { LastFive } from '../models/games/games.models';
import { StatsService } from '../services/stats/stats-service';

@Component({
  selector: 'app-last-opposition',
  standalone: false,
  // imports: [],
  templateUrl: './last-opposition.component.html',
  styleUrl: './last-opposition.component.scss'
})
export class LastOppositionComponent {

  @Input() homeTeam: string;
  @Input() roadTeam: string;
  lastOpposition: LastFive;
  lastGamesRoad: LastFive;
  lastGamesHome: LastFive;

  constructor(private statsService: StatsService) {}

  async ngOnInit(): Promise<void> {
      this.statsService
        .getLastOppositionGame(this.homeTeam, this.roadTeam)
        .subscribe(
          (lastOpposition) => {
            
            this.lastOpposition = lastOpposition;
          },
          (error) => {
            console.log("homeTeam => ", this.homeTeam);
            console.log("roadTeam => ", this.roadTeam);
            
            console.error("Error fetching last Opposition games ROAD:", error);
          }
        );
  }

}
